import { QueryFilterBannerForm } from '@seek/cmsu-components/src/modules/Talent-Attraction-Lab/components/QueryFilterBanner/QueryFilterBannerForm';
import type { DatalabSurvey } from '@seek/cmsu-components/src/modules/Talent-Attraction-Lab/datalabHelper';

// WIP: This component is not yet done

export const QueryFilterTAL = ({
  datalabSurvey,
}: {
  datalabSurvey?: DatalabSurvey;
}) => <QueryFilterBannerForm datalabSurvey={datalabSurvey} />;
